import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { IFileUpload, PhotoData } from '@ui-app/models/common.models';
import { FileUploadService } from '@ui-app/components/file-upload/file-upload.service';

@Injectable()
export class S3UploadMockService extends FileUploadService implements IFileUpload {

    private readFile(file: File): Observable<ArrayBuffer | string> {
        const reader = new FileReader();

        return new Observable<ArrayBuffer | string>(
            (observer) => {
                reader.onloadend = () => {
                    let arrayBuffer: ArrayBuffer | string = reader.result;
                    observer.next(arrayBuffer);
                    arrayBuffer = null;
                };
                reader.readAsDataURL(file);
            }
        );
    }

    uploadFile(file: File): Observable<PhotoData> {
        const fileGuid: string = Math.random().toString().slice(-12);

        return timer(1000)
            .pipe(
                switchMap(() => this.readFile(file)),
                map((dataImage: string) => ({
                    dataImage,
                    uId: fileGuid
                })),
            );
    }
}
